import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import { brandColors } from '../theme/theme';
import { getFilmTrackingStats } from '../modules/FilmTracking/services/filmTrackingService';
import FilmDashboardBanner from '../components/FilmTracking/FilmDashboardBanner';
import ThisWeekWidget from '../components/FilmTracking/ThisWeekWidget';

const Home = () => {
  const [filmStats, setFilmStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const statsData = await getFilmTrackingStats();
        setFilmStats(statsData);
      } catch (error) {
        console.error('Failed to fetch film dashboard stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  return (
    <Box>
      {/* Welcome Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h3" sx={{ mb: 1, color: brandColors.secondary }}>
          Welcome to Greenlight Analytics
        </Typography>
        <Typography variant="h6" sx={{ color: 'text.secondary', fontWeight: 400 }}>
          Your comprehensive platform for film and television measurement
        </Typography>
      </Box>

      {/* Film Dashboard Banner */}
      {loading && !filmStats ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 160, mb: 4 }}>
          <CircularProgress size={48} />
        </Box>
      ) : (
        <FilmDashboardBanner stats={filmStats || {}} />
      )}

      {/* This Week's Releases Widget */}
      <ThisWeekWidget />
    </Box>
  );
};

export default Home;
